import * as React from 'react';
import { PageWrap } from '../../layouts';
import { H1, H3 } from '../../typography';

type MaintenanceProps = {};

const Maintenance: React.FC<MaintenanceProps> = props => {
  return (
    <PageWrap
      height="calc(100vh / var(--ib-ui-scale, 1))"
      alignItems="center"
      flexDirection="column"
      justifyContent="center"
    >
      <H1 mb={4} color="primary">
        The site is currently down for maintenance.
      </H1>
      <H3>We apologize for any inconveniences caused</H3>
    </PageWrap>
  );
};

export default Maintenance;
